import { useEffect } from "react";

const upsert = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function Seo({ title, description, path = "/" }) {
  useEffect(() => {
    document.title = title;
    upsert("name", "description", description);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:url", `https://riverstonepartners.info${path}`);
    upsert("property", "og:image", `${window.location.origin}/images/hero-poster.jpg`);
  }, [title, description, path]);
  return null;
}
